<template>
    <div class="rating-form-section-content-item">
        <h5 class="rating-form-section-item-title">
            <div class="index">{{indexIn+1}}.</div>{{itemIn.title}}
            <span class="points" v-if="itemIn.type === 1 && sectionIn.type === 1">
                ({{itemIn.max}}pt)
            </span>
            <div class="weight" v-if="sectionIn.type !== 0">
                {{ `weging: ${itemIn.weight}` }}
            </div>
        </h5>

        <div class="rating-form-section-item-explanation">
            <design-2021-apprentice-display-html-component v-if="itemIn.description" :html-content="itemIn.description">
            </design-2021-apprentice-display-html-component>
        </div>

        <design-2021-rating-answer-component :item-in="itemIn"
                                             :rating-form-id="ratingIn.forms[0].id"
                                             @updateOpenAnswer="onOpenAnswer($event, itemIn)"
                                             v-if="itemIn.type === 1">
        </design-2021-rating-answer-component>

        <design-2021-rating-answer-option-component :item-in="itemIn"
                                                    :rating-form-id="ratingIn.forms[0].id"
                                                    :section-in="sectionIn"
                                                    @updateClosedAnswer="onClosedAnswer($event, itemIn)"
                                                    v-else>
        </design-2021-rating-answer-option-component>
    </div>
</template>

<script>
export default {
    name: "design-2021-rating-tab-rating-section-item-component",
    props: {
        sectionIn: {
            type: Object,
            required: true,
        },
        itemIn: {
            type: Object,
            required: true,
        },
        indexIn: {
            type: Number,
            required: true,
        },
        ratingIn: {
            type: Object,
            required: true,
        }
    },
    methods: {
        onOpenAnswer(value, item) {
            item.answers = [];
            item.answers[0] = {};
            item.answers[0].rating_form_id = this.ratingIn.forms[0].id;
            item.answers[0].open_answer = value;
        },

        onClosedAnswer(value, item) {
            item.answers = [];
            item.answers[0] = {};
            item.answers[0].rating_form_id = this.ratingIn.forms[0].id;
            item.answers[0].rating_option_id = value;
        },
    }
}
</script>

<style scoped lang="scss">
    .rating-form-section-content-item {
        padding: map-get($grid-gutter-spacing, 'twenty-one') map-get($grid-gutter-spacing, 'fifteen');

        .rating-form-section-item-title{
            margin-bottom: map-get($grid-padding-spacing, 'fifteen');
            .index {
                display: inline-block;
                width: 21px;
                text-align: right;
                margin-right: 9px;
            }

            .points {
                font-size: $base-font-size;
            }
        }

        .weight,
        .rating-form-section-item-explanation {
            margin-left: $grid-gutter-width;
        }

        .weight {
            font-size: 0.75rem;
            color: $primary;
        }

        .rating-form-section-item-explanation {
            color: $text-muted-color;
            margin-bottom: $grid-gutter-width;
        }

        &:nth-child(odd){
            background-color: $secondary-background-color;
        }
    }
</style>
